export const devProjects = [
    {
        id: "noteworthy",
        year: 2022,
        title: "Noteworthy",
        image: "projects/notescribe.jpg",
        link: "https://noteworthynotes.herokuapp.com/",
        collab: "Solo work",
        stack: ["React.js", "Express.js", "MongoDB"],
        explanation:
            "Developed a smart meeting transcription platform that automatically records, highlights, and organizes discussions. Noteworthy allows users to label and categorize key insights, view contextual connections within transcripts, and analyze meeting data for actionable insights. Awarded 3rd Place at MIT Web Lab 2022.",
        prize: "MIT Web Lab 2022 3rd Place Prize",
        featured: true,
    },
    {
        id: "cube",
        year: 2017,
        title: "The Cube",
        image: "projects/cube.gif",
        link: "https://jaeyoon.io/cube",
        collab: "Solo work",
        stack: ["Vanilla JS"],
        explanation:
            "Created an experimental 3D navigation interface using pure JavaScript as a final project for USC’s Interactive Web Development course. Designed a rotating cube UI to explore unconventional web interaction patterns. Ranked 1st in the class and received the highest grade (A).",
        featured: true,
    },
    {
        id: "dance",
        year: 2021,
        title: "A Chrome Extension for Dance Practice",
        image: "projects/dance.jpg",
        link: "https://chrome.google.com/webstore/detail/mirror-youtube-for-dance/odmglmjpojlhploiiaemcdohkeoapakf",
        collab: "Solo work",
        stack: ["Chrome Extension"],
        explanation:
            "Developed a Chrome extension that mirrors YouTube videos for dance practice, enabling users to follow choreography more easily. Reached over 2,000 active users and was featured on the Chrome Web Store.",
        prize: "Featured on Chrome Store (2,000+ users)",
        featured: true,
    },
    {
        id: "minglr",
        year: 2020,
        title: "Minglr",
        image: "projects/minglr.jpg",
        link: "https://minglr.us",
        code: "https://github.com/CCI-MIT/minglr",
        collab: "Solo work",
        stack: ["React.js", "Express.js", "MongoDB", "Socket.io", "Jitsi"],
        explanation:
            "Built a web platform that facilitates ad hoc video conversations at virtual conferences. Successfully deployed at two major academic events with over 450 participants. Contributed to enhancing spontaneous networking in remote conference settings.",
        featured: true,
    },
    {
        id: "history",
        year: 2018,
        title: "Visualizing Korean Independence Movement",
        image: "projects/history.jpeg",
        link: "https://jaeyoon.io/infovis",
        code: "https://github.com/jyoonsong/hci-project",
        collab: "Teamwork (a team of two)",
        stack: ["D3.js"],
        explanation:
            "Developed a data visualization showcasing the structure and connections of Korean independence organizations from 1910 to 1945 using D3.js. Designed interactive visuals to enhance historical data exploration.",
    },
    {
        id: "ravi",
        year: 2018,
        title: "Real-time Collaborative Video Chat Summarization",
        image: "projects/ravi.jpeg",
        code: "https://github.com/jyoonsong/RAVi",
        collab: "Solo work",
        stack: ["Chrome Extension", "Python"],
        explanation:
            "Built a browser extension inspired by Tilda (Zhang & Cranshaw, 2018) that enables users to tag and annotate key moments during live video chats, supporting collaborative note-taking and conversation summarization.",
    },
    {
        id: "samsung",
        year: 2018,
        title: "Restaurant Recommendation App",
        image: "projects/samsung.jpeg",
        collab: "Teamwork (a team of 5)",
        stack: ["React.js", "Express.js", "Python"],
        explanation:
            "Designed and developed a personalized restaurant recommendation system using collaborative filtering and sentiment analysis on user reviews. Selected as a Top Ten Finalist at the Samsung AI Hackathon.",
        prize: "Top Ten Finalist at Samsung AI Hackathon",
    },
    {
        id: "who2chat",
        year: 2021,
        title: "Who2chat",
        image: "projects/who2chat.png",
        link: "https://who2chat.com/",
        collab: "Teamwork (a team of 2)",
        stack: ["React.js", "Firebase", "Jitsi"],
        explanation:
            "Developed the second iteration of Minglr for academic conferences. Deployed successfully at UIST 2021 and CSCW 2021, supporting spontaneous one-on-one video conversations among attendees.",
    },
    {
        id: "magicspell",
        year: 2021,
        title: "A magic spell for me",
        image: "projects/img-1-small.jpeg",
        collab: "Solo work",
        stack: ["React.js"],
        explanation:
            "An interactive web experience exploring self-affirmation and inspiration through the concept of ‘magic spells.’ Designed and developed with a focus on playful visual storytelling using React.js.",
    },
    {
        id: "solutionChat",
        year: 2019,
        title: "SolutionChat",
        link: "https://doi.org/10.1145/3313831.3376609",
        image: "projects/solutionchat.jpeg",
        collab: "Teamwork (Team of Two)",
        stack: ["Angular.dart", "HTML/CSS"],
        explanation:
            "Contributed to the development of an interactive chat interface designed to support collaborative problem-solving. Focused on building and optimizing the front-end user experience.",
    },
    {
        id: "soundglance",
        year: 2018,
        title: "SoundGlance",
        link: "https://doi.org/10.1145/3290607.3312865",
        code: "https://github.com/SoundGlance/tag-me",
        image: "projects/soundglance_tagging.jpg",
        collab: "Solo work",
        stack: ["Ruby on Rails"],
        explanation:
            "Developed a web interface to generate datasets for a CNN-based accessibility tool that summarizes visual web content for screen reader users. Used in the SoundGlance research project published at CHI 2019.",
    },
    {
        id: "suggestbot",
        year: 2018,
        title: "SuggestBot",
        image: "projects/suggestbot.jpeg",
        collab: "Teamwork (Team of two)",
        stack: ["React.js", "Ruby on Rails"],
        explanation:
            "Built an interface to crowdsource supporting evidence for online posts using Mechanical Turk. Designed the workflow and front-end logic for scalable data collection.",
    },
    {
        id: "writing",
        year: 2021,
        title: "Story writing experiment platform",
        image: "projects/story.gif",
        collab: "Solo work",
        stack: ["React.js", "Empirica.js", "Meteor"],
        explanation:
            "Developed an online experimental platform to collect short story data from participants via Upwork. Integrated real-time collaboration and data management using Empirica.js and Meteor.",
    },
    {
        id: "stampcookies",
        year: 2021,
        title: "Stamp Cookies Mobile Game",
        image: "projects/cookies.png",
        link: "https://drive.google.com/file/d/1RGKYJNpZxTdZN9zPai-BIS8rZoyQAjGL/view",
        collab: "Solo work",
        stack: ["React Native"],
        explanation:
            "Created a mobile game where players stamp cookies with patterns and earn points based on accuracy and speed. Built using React Native for cross-platform deployment.",
    },
    {
        id: "dobbies",
        year: 2021,
        title: "HCI & The Seven Dobbies",
        image: "projects/dobbies.png",
        link: "https://studyhci.netlify.app/",
        collab: "Solo work",
        stack: ["Gatsby", "Netlify"],
        explanation:
            "Developed a modern, static website for an HCI study club using Gatsby and Netlify. Focused on lightweight design and fast deployment for community resource sharing.",
    },
    {
        id: "ffaper",
        year: 2021,
        title: "FFA:PER",
        image: "projects/ffaper.png",
        // link: "https://ffaper.com/",
        collab: "Solo work (Freelancer contract via Kmong)",
        stack: ["Ruby on Rails"],
        explanation:
            "Developed an e-commerce website for a fashion brand, focusing on responsive UI and efficient product management. Delivered as a freelance project via Kmong.",
    },
    {
        id: "psnm",
        year: 2021,
        title: "SKT PS&M Event Website",
        image: "projects/psnm.png",
        // link: "https://www.tworldevent.com",
        collab: "Solo work (Freelancer contract via Kmong)",
        stack: ["Ruby on Rails"],
        explanation:
            "Designed and implemented an event microsite for SKT PS&M, optimizing for scalability and user engagement during a nationwide promotional campaign.",
    },
    {
        id: "covidhere",
        year: 2021,
        title: "Covidhere",
        image: "projects/covidhere.png",
        // link: "http://covidhere.herokuapp.com/2/1",
        collab: "Solo work (Freelancer contract via Kmong)",
        stack: ["Ruby on Rails"],
        explanation:
            "Built a public information website displaying real-time COVID-19 case data for Yongin-si, South Korea. Focused on clarity, accessibility, and automated data updates.",
    },
    {
        id: "chartmetric",
        year: 2017,
        title: "Internship at Chartmetric",
        image: "projects/chartmetric.jpeg",
        link: "http://chartmetric.io",
        collab: "Internship",
        stack: ["Angular.js", "Highcharts.js"],
        explanation:
            "Contributed to improving data visualization features for the music analytics platform Chartmetric. Implemented interactive chart components using Highcharts.js and Angular.js during a short-term internship.",
    },
    {
        id: "truth101",
        year: 2017,
        title: "Truth 101",
        image: "projects/truth101.png",
        // link: "http://truth-101.github.io",
        collab: "Teamwork (Led a team of four)",
        stack: ["D3.js"],
        explanation:
            "Led a team of four to develop an interactive data visualization project exploring the spread of misinformation. Designed dynamic visual components using D3.js to communicate complex datasets effectively.",
    },
    // {
    //     id: "refugees",
    //     title: "Are Refugees Dangerous?",
    //     year: 2018,
    //     image: "projects/img-2-small.jpeg",
    //     link: "https://jaeyoon.io/dt4c",
    //     collab: "Solo work",
    //     stack: ["D3.js"],
    //     explanation:
    //         "The topic of my project was refugees, more specifically the Yemeni Muslim refugees coming to Jeju island in South Korea. To narrow down the scope of the topic, I tried to put emphasis on the question if the refugees are dangerous and likely to be involved in a crime in particular. I didn’t explicitly answer the question, but instead tried to focus more on delivering the data itself so that the reader wouldn’t feel that they are being forced to be on one side. One example is the case of Sweden in which I showed both increasing and decreasing crime rate due to accepting refugees. This implies that the number of refugees have nothing to do with the crime rate, showing neither positive nor negative correlation. <br><br> I spent a lot of time searching for factual data—I even read the German official police report using Google translation in order to keep the objectivity using the rawest data. Because of this, the resulting infographic was less visually engaging, and sometimes even misleading due to wrong usage of visual devices.<br><br>The infographic first points out what the people think about the refugees, which has also been a motivation for this project. Then, it points out how crime rate of refugees or foreigners are not so different from other people, giving example of Germany, Norway, and South Korea. Lastly, it suggests that maybe the reason for the difference between people's perspective and what data really says is partially because of what media highlight.",
    // },
];
